import { notification } from 'antd';
import { NotificationPlacement } from 'antd/lib/notification';

export type NotificationType = 'info' | 'error' | 'warn' | 'success';

export interface NotificationProps {
    type: NotificationType;
    messageTitle: string;
    description: string;
    key?: string;
    duration?: number;
    placement?: NotificationPlacement;
}

const Notification = (props: NotificationProps) => {
    const duration = props.duration;
    notification[props.type]({
        key: props.key,
        message: props.messageTitle,
        description: props.description,
        duration,
        placement: props.placement ?? 'top',
    });
};

export default Notification;
